import { render, staticRenderFns } from "./online.vue?vue&type=template&id=56f53f2e&scoped=true"
import script from "./online.vue?vue&type=script&lang=js"
export * from "./online.vue?vue&type=script&lang=js"
import style0 from "./online.vue?vue&type=style&index=0&id=56f53f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f53f2e",
  null
  
)

export default component.exports